import script from "./InputSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSelect.vue?vue&type=script&setup=true&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=771131e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771131e8"]])

export default __exports__